<template>
  <div class="maxvalu-kantou-flyer-cards">
    <div class="maxvalu-kantou-flyer-cards__items">
      <maxvalu-kantou-flyer-card
        v-for="(item, index) in items"
        v-bind="item"
        :key="index"
        :shop-id="shopId"
        :location="getLocation(index)"
        @click="emitClick($event)"
        @intersect="emitIntersect"
      />
    </div>
    <!-- <div
      class="maxvalu-kantou-flyer-cards__more-btn"
      :class="{ hidden: isActive || items.length < 3 }"
      @click="onClick"
    >
      <span>もっと見る</span>
    </div> -->
  </div>
</template>

<script setup>
import MaxvaluKantouFlyerCard from '@/components/MaxvaluKantouFlyerCard'

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  shopId: {
    type: [Number, String, null],
    default: null,
  },
  location: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['height:update', 'click', 'intersect'])
 
const isActive = ref(false)

const onClick = () => {
  isActive.value = true
  const interval = setInterval(() => {
    const items = document.querySelectorAll(
      '.maxvalu-kantou-flyer-card.hidden'
    )
    if (!items?.length) {
      clearInterval(interval)
      emit('height:update')
    }
  }, 100)
}

const emitClick = (obj) => {
  emit('click', obj)
}

const emitIntersect = (data) => {
  emit('intersect', data)
}

const handleClick = () => {
  isActive.value = true
}

const getLocation = (index) => {
  if (props.location) {
    const newLocation = { ...props.location }
    newLocation.element_line_number = index + 1
    return newLocation
  }
  return null
}
</script>

<style lang="scss" scoped>
.maxvalu-kantou-flyer-cards {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .maxvalu-kantou-flyer-cards__items {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    position: relative;
    & > .hidden {
      display: none;
      @media screen and (min-width: 440px) {
        display: block;
      }
    }
  }
  .maxvalu-kantou-flyer-cards__more-btn {
    width: 240px;
    height: 30px;
    margin: 10px 0;
    font-weight: 700;
    border-radius: 15px;
    font-size: 16px;
    background-color: #aa187a;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    &.hidden {
      display: none;
    }
    &:hover {
      cursor: pointer;
    }
    @media screen and (min-width: 440px) {
      display: none;
    }
  }
}
</style>
